/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';


class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="ad2b370d-36a7-435a-a8b1-6b9ae7be018e" viewBox="0 0 25.27 17.6" width="25.27" height="17.6" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
  <g id="a65849a2-08d3-403a-96ce-38e14807cbc7">
    <g id="aa8b2e47-3a0f-4cbe-9fe8-11837d8cbdfb">
      <g id="e0faf353-b9ed-4ffd-b015-238cec1ec586">
        <g id="e408c8e8-8f28-45e7-8847-3ea3ac70a579">
          <path id="a418bacf-d46e-434f-be38-627d8abd3c70" d="M10,14.42,3.55,8C2.25,6.62.33,8.7,1.69,10L9,17.34a1.32,1.32,0,0,0,1.85,0L25.54,3.05C26.86,1.8,25-.2,23.72,1Z" transform="translate(-0.97 -0.38)" style={{fill: "#00487c",stroke: "#0e497b",strokeWidth: "0.5px"}} className="icon-fill"/>
        </g>
      </g>
    </g>
  </g>
</svg>

    );
  }
}

Icon.displayName = 'CheckmarkBoldIcon';

export default Icon;
